import { paletteFor } from '@/utils/subjects'
import { SubjectGlyph } from '@/components/aurora'

export default function SubjectTile({ subject, examCount = 0, certCount = 0, onClick }) {
  const palette = paletteFor(subject)
  return (
    <button
      onClick={onClick}
      className={`${palette} flex-shrink-0 w-[130px] h-[130px] text-left flex flex-col justify-between p-3.5 rounded-2xl border transition-all hover:-translate-y-0.5 cursor-pointer`}
      style={{
        background: 'var(--surface)',
        borderColor: 'var(--border)',
        boxShadow: 'var(--shadow-sm)',
        scrollSnapAlign: 'start',
      }}
      onMouseEnter={e => { e.currentTarget.style.boxShadow = 'var(--shadow-md)' }}
      onMouseLeave={e => { e.currentTarget.style.boxShadow = 'var(--shadow-sm)' }}
    >
      <SubjectGlyph subject={subject} size="sm" />
      <div className="mt-1.5">
        <div
          className="text-[14px] font-bold tracking-tight"
          style={{ color: 'var(--s-tint, var(--coral))' }}
        >
          {subject?.name ?? '—'}
        </div>
        <div className="mt-0.5 font-mono text-[10.5px] tracking-wide" style={{ color: 'var(--ink-3)' }}>
          {examCount}{certCount > 0 ? ` · ${certCount} sert` : ' imtihon'}
        </div>
      </div>
    </button>
  )
}
